import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class DashboardOverviewEffects {


  constructor(private actions$: Actions) {}
}
